/* Model */
class SkuGroupModel extends App.Models.BaseModel {
  modelUrl = 'SkuGroup';
}

App.Models.SkuGroup = SkuGroupModel;

/* Collection */
class SkuGroupCollection extends App.Collections.BaseCollection {
  url = 'SkuGroup';
  model = App.Models.SkuGroup;
}

App.Collections.SkuGroups = SkuGroupCollection;

/* Router */
class SkuGroupRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'SkuGroup';
      const model = App.Models.SkuGroup;
      const collectionClass = App.Collections.SkuGroups;

      super(entityName, model, collectionClass);
  }
}

App.Routers.SkuGroup = SkuGroupRouter;
